<template>
  <div class="app-container">
    <div class="line-box">
      <div class="w-line"></div>
      <div class="h-line"></div>
    </div>
    <div class="flex-box">
      <div class="md_index_item">
        <div class="md_item_box" @click="userOpen = true">
          <img :src="require('@/assets/img/pop_account.png')" alt="">
          <span>账户</span>
        </div>
      </div>
      <div class="md_index_item">
        <div class="md_item_box" @click="noticeOpen = true">
          <img :src="require('@/assets/img/pop_announcement.png')" alt="">
          <span>公告</span>
        </div>
      </div>
      <div class="md_index_item">
        <div class="md_item_box" @click="giftOpen = true">
          <img :src="require('@/assets/img/pop_gift.png')" alt="">
          <span>礼包</span>
        </div>
      </div>
      <div class="md_index_item">
        <div class="md_item_box" @click="customerOpen = true">
          <img :src="require('@/assets/img/pop_service.png')" alt="">
          <span>客服</span>
        </div>
      </div>
    </div>
    <div class="hd" v-if="init.event_info.status" @click="showIframeBox">
      <img :src="init.event_info.icon" alt="">
    </div>
    <mu-dialog class="mudia" :padding="20" width="360" scrollable :open.sync="userOpen" :overlay-close="false">
      <div class="md_title" :style="{background: themeConfig.dark}">
        <div class="md_title_txt" :style="{color: themeConfig.light}">账号</div>
        <mu-icon class="icon" size="30" value="close" color="white" @click="userOpen = !userOpen"></mu-icon>
      </div>
      <div class="md_content">
        <user ref="user" />
      </div>
    </mu-dialog>
    <!-- 公告 -->
    <mu-dialog class="mudia" :padding="20" width="360" scrollable :open.sync="noticeOpen" :overlay-close="false">
      <div class="md_title" :style="{background: themeConfig.dark}">
        <div class="md_title_txt" :style="{color: themeConfig.light}">公告</div>
        <mu-icon class="icon" size="30" value="close" color="white" @click="noticeOpen = !noticeOpen"></mu-icon>
      </div>
      <div class="md_content">
        <notice />
      </div>
    </mu-dialog>
    <!-- 礼包 -->
    <mu-dialog class="mudia" :padding="20" width="360" scrollable :open.sync="giftOpen" :overlay-close="false">
      <div class="md_title" :style="{background: themeConfig.dark}">
        <div class="md_title_txt" :style="{color: themeConfig.light}">礼包</div>
        <mu-icon class="icon" size="30" value="close" color="white" @click="giftOpen = !giftOpen"></mu-icon>
      </div>
      <div class="md_content">
        <gift />
      </div>
    </mu-dialog>
    <!-- 客服 -->
    <mu-dialog class="mudia" :padding="20" width="360" scrollable :open.sync="customerOpen" :overlay-close="false">
      <div class="md_title" :style="{background: themeConfig.dark}">
        <div class="md_title_txt" :style="{color: themeConfig.light}">客服</div>
        <mu-icon class="icon" size="30" value="close" color="white" @click="customerOpen = !customerOpen"></mu-icon>
      </div>
      <div class="md_content">
        <customer />
      </div>
    </mu-dialog>

    <!-- iframe弹窗 -->
    <mu-dialog class="mudia bgopacity0" v-if="init.event_info.status" :padding="0" :width="'83%'" max-width="100%" scrollable :open="iframeBox" :overlay-close="false">
      <div class="wrap" :style="`height:${IFHeight}px;overflow-y:auto;-webkit-overflow-scrolling: touch;`">
        <iframe class="iframe" :src="hdIframeUrl" frameborder="0" allowtransparency="yes" :style="`width: 100%; height:${IFHeight}px;display: block;overflow: hidden;`"></iframe>
      </div>
      <div class="md_bottom">
        <mu-icon class="icon" size="30" value="close" color="white" @click="iframeBox = !iframeBox"></mu-icon>
      </div>
    </mu-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import User from './User'
import Notice from './Notice'
import Customer from './Customer'
import Gift from './Gift'
import { getSession } from '@/utils'

export default {
  name: 'DrawIndex',
  props: {
    realName: {
      type: Boolean,
      default: false
    },
    bindPhoneStatus: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    realName (val) {
      if (val) {
        this.userOpen = true
        this.$nextTick(() => {
          this.$refs.user.showRealName()
        })
      }
    },
    bindPhoneStatus (val) {
      if (val) {
        this.userOpen = true
        this.$nextTick(() => {
          this.$refs.user.showBindPhone()
        })
      }
    }
  },
  components: {
    User,
    Notice,
    Gift,
    Customer
  },
  data () {
    return {
      IFWidth: 0,
      IFHeight: 0,
      userOpen: false,
      noticeOpen: false,
      giftOpen: false,
      customerOpen: false,
      iframeBox: false,
      hdIframeUrl: ''
    }
  },
  methods: {
    refesh () {
      location.reload()
    },
    download () {
      window.location.href = this.$store.getters.init.game_info.download_url
    },
    // 调整iframe框全屏大小
    fullIframe () {
      this.IFHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
      this.IFWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
      this.IFHeight = this.IFHeight * 0.95 - 40
      this.IFWidth = Math.ceil(this.IFWidth * 0.95)
      this.$nextTick(() => {
        window.addEventListener('orientationchange', () => {
          setTimeout(() => {
            this.IFHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
            this.IFWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
            this.IFHeight = this.IFHeight * 0.95 - 40
            this.IFWidth = Math.ceil(this.IFWidth * 0.95)
          }, 350)
        })
      })
    },
    showIframeBox () {
      if (this.gameData.dataType === 3) {
        this.hdIframeUrl = `${this.init.event_info.address}?server_id=${this.gameData.serverID}&role_id=${this.gameData.roleID}&server_name=${this.gameData.serverName}&role_name=${this.gameData.roleName}&phpsessid=${getSession()}&game_id=${this.gameData.appid}&userid=${this.gameData.userId}`
        this.iframeBox = true
      } else {
        this.$toast.error('请先进入游戏')
      }
    },
    checkUser () {
      if (this.realName) {
        this.userOpen = true
        this.$nextTick(() => {
          this.$refs.user.showRealName()
        })
      } else if (this.bindPhoneStatus) {
        this.userOpen = true
        this.$nextTick(() => {
          this.$refs.user.showBindPhone()
        })
      }
    }
  },
  computed: {
    ...mapGetters([
      'status',
      'theme',
      'init',
      'isHorizontal',
      'themeConfig',
      'gameData'
    ])
  },
  mounted () {
    this.fullIframe()
    this.checkUser()
  }
}
</script>

<style lang="less" scoped>
.app-container {
  position: relative;
  .line-box {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 0;
    width: 100%;
    height: 4.02rem;
    .w-line {
      width: 100%;
      border-bottom: .01rem solid #ccc;
      position: absolute;
      top: 50%;
      left: 0;
    }
    .h-line {
      width: 0;
      height: 4.02rem;
      border-right: .01rem solid #ccc;
      position: absolute;
      top: 0;
      left: 50%;
    }
  }
}

.md_item_box {
  width: 1.2rem;
  height: 1.2rem;
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  img {
    display: block;
    width: .6rem;
    margin: .1rem auto;
  }
  span {
    color: #333;
  }
}

.hd {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  width: 1.2rem;
  height: 1.2rem;
  z-index: 2;
  img {
    display: block;
    width: 1.2rem;
  }
}

.iframe-box {
  position: fixed;
  top: 0;
  left: 0;
}
.bgopacity0 {
  /deep/ .mu-dialog {
    background: rgba(0, 0, 0, 0.4);
  }
}

.mudia {
  /deep/ .mu-dialog-body {
    padding: 0;
  }
  /deep/ .mu-dialog {
    border-radius: .14rem;
    overflow: hidden;
  }
  /deep/ .mu-tab {
    font-size: 12px;
  }
}
</style>
